export type TModalShowMultiSelect = <T>(config: ISelConfig<T>) => PromiseLike<void>;

/** Config for a Modal Reorder Show */
export interface ISelConfig<T> {
    /** Base array of currently chosen items to display */
    ChosenItems: T[];
    /** Chosen items must be subSet! */
    AllItems: T[];
    /** Caption of the left side (unchosen items) */
    TitleUnchosen: string;
    /** Caption of the right side (chosen items) */
    TitleChosen: string;
    /** Template for the left side (unchosen items) */
    TemplateUnchosen?: any;
    /** Template for the right side (chosen items) */
    TemplateChosen?: any;
    TemplateUrlUnchosen?: string;
    TemplateUrlChosen?: string;
    context?: JQuery | Element;
    title?: string;
    events?: {
        /** function to apply current pending state */
        apply?: (items: T[]) => any,
        /** function to revert current pending state */
        revert?: () => any;
    };
    filter: (item: T, text: string) => boolean;
}

/** TODO: Not yet fully decoupled */
export function RegisterModalShowMultiSelect(f: TModalShowMultiSelect) {
    _ModalShowMultiSelect = f;
}
var _ModalShowMultiSelect: TModalShowMultiSelect = c => {
    throw new Error('ModalShowMultiSelect: not registered!');
};
export function ModalShowMultiSelect<T>(config: ISelConfig<T>): PromiseLike<void> {
    return _ModalShowMultiSelect(config);
}
